import { render } from "./CIS-Resource-Benchmark.vue?vue&type=template&id=10c5b3d6&scoped=true"
import script from "./CIS-Resource-Benchmark.vue?vue&type=script&lang=js"
export * from "./CIS-Resource-Benchmark.vue?vue&type=script&lang=js"

import "./CIS-Resource-Benchmark.vue?vue&type=style&index=0&id=10c5b3d6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10c5b3d6"]])

export default __exports__